export default __webpack_public_path__ + "static/media/happy_town.a2f2cd42.png";